<template>
  <div class="zzzd_BEContainer" v-if="isShow">
    <div class="zzzd_BEWrapper">
      <!-- 进度条 -->
      <div class="zzzd_steps">
        <div class="zzzd_circle active_icon">
          <i class="el-icon-check"></i>
        </div>
        <div class="zzzd_step active">基础评估</div>
        <div class="zzzd_line"></div>
        <div class="zzzd_circle active">2</div>
        <div class="zzzd_step active">信息提交</div>
        <div class="zzzd_line"></div>
        <div class="zzzd_circle">3</div>
        <div class="zzzd_step">智能诊断</div>
        <div class="zzzd_line"></div>
        <div class="zzzd_circle">4</div>
        <div class="zzzd_step">诊断结果</div>
      </div>
      <div class="zzzd_title">基础评估</div>
      <!-- 基础资质 -->
      <div class="zzzd_table" v-if="baseList">
        <div class="zzzd_th">请选出您已经拥有的基础资质</div>
        <div class="zzzd_td">
          <el-checkbox-group v-model="checkbaseList" v-if="ifRequire">
            <el-checkbox
              :label="item.name"
              v-for="(item,baseIndex) in baseList"
              :key="baseIndex"
              @change="chooseBase(item)"
              style="margin-bottom:20px"
            ></el-checkbox>
          </el-checkbox-group>
          <div class="zzzd_item" v-else>暂停接受入驻</div>
        </div>
      </div>
      <!-- 品牌 资质 -->
      <div class="zzzd_table" v-if="brandList">
        <div class="zzzd_th">请选出您已经拥有的品牌资质</div>
        <div class="zzzd_td">
          <el-checkbox-group v-model="checkBrandList" v-if="ifRequire">
            <el-checkbox
              :label="item.name"
              v-for="(item,baseIndex) in brandList"
              :key="baseIndex"
              @change="chooseBase(item)"
              style="margin-bottom:20px"
            ></el-checkbox>
          </el-checkbox-group>
          <div class="zzzd_item" v-else>暂停接受入驻</div>
        </div>
      </div>
      <!-- 行业资质 -->
      <div class="zzzd_table" v-if="industryList">
        <div class="zzzd_th">请选出您已经拥有的行业资质</div>
        <div class="zzzd_td">
          <el-checkbox-group v-model="checkindustryList" v-if="ifRequire">
            <el-checkbox
              :label="item.name"
              v-for="(item,baseIndex) in industryList"
              :key="baseIndex"
              @change="chooseBase(item)"
              style="margin-bottom:20px"
            ></el-checkbox>
          </el-checkbox-group>
          <div class="zzzd_item" v-else>暂停接受入驻</div>
        </div>
      </div>
      <!-- 评估方式 -->
      <div class="zzzd_table">
        <div class="zzzd_th">您要选择评估方式</div>
        <div class="zzzd_td">
          <el-radio-group v-model="evaluateWay" v-if="ifRequire">
            <el-radio :label="true">智能评估</el-radio>
            <el-radio :label="false">人工评估</el-radio>
          </el-radio-group>
          <div class="zzzd_item" v-else>暂停接受入驻</div>
        </div>
      </div>
      <!-- 上传材料 -->
      <div class="zzzd_table" v-if="!evaluateWay">
        <div class="zzzd_th">材料上传</div>
        <div class="zzzd_td" style="padding:0">
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="name" label="材料名称" width="180"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-upload
                  :action="imgUrl"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :file-list="fileList"
                  :http-request="imgUpload"
                  :data="scope.row"
                  :limit="1"
                >
                  <div class="el-upload__text">
                    <em>点击上传图片</em>
                  </div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" append-to-body>
                  <img width="100%" height="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- <div class="zzzd_title" v-if="ifRequire">输入企业联系人信息</div>
      <el-form
        v-if="ifRequire"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        :inline="true"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业名称" prop="name" class="zzzd_name">
              <el-input v-model="ruleForm.name" placeholder="请输入企业名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="phone" class="zzzd_phone">
              <el-input v-model="ruleForm.phone" placeholder="请输入联系电话" maxlength="11"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button @click="submitForm('ruleForm')">开始入驻评估</el-button>
        </el-form-item>
      </el-form>-->
      <el-button @click="submitForm" class="startBtn">开始入驻评估</el-button>
      <el-dialog :visible.sync="submitVisible" width="30%" center>
        <div>
          <div class="up_circle active">
            <i class="el-icon-check"></i>
          </div>
        </div>
        <div style="text-align:center">
          <span>认证已提交，请留意审核结果</span>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="viewNow"
            style="background:#d7443f;border-color:#d7443f"
          >查看认证</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  getQualificationByIndustry, // 获取所需资质
  manualEvaluation, //人工评估
} from "@/api/qualification.js";
import { getOss } from "@/api/tmTools";
import { logout } from "@/api/user";
import { getCookie, removeCookie } from "@/utils/getToken.js";
import axios from "axios";
export default {
  data() {
    let validateName = (rule, value, callback) => {
      let reg = /\S/g;
      if (!reg.test(value)) {
        callback(new Error("公司名称不能为空"));
      } else {
        callback();
      }
    };
    let validatePhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (!reg.test(value)) {
        callback(new Error("格式不正确"));
      } else {
        callback();
      }
    };
    return {
      active: 0,
      // 已选择的资质的数组
      checkbaseList: [],
      checkBrandList: [],
      checkindustryList: [],
      evaluateWay: true,
      // 所有的资质的数组
      baseList: [],
      baseId: 0,
      brandList: [],
      brandId: 0,
      industryList: [],
      industryId: 0,
      isShow: false,
      ruleForm: {
        name: "",
        phone: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
          {
            validator: validateName,
            message: "请输入企业名称",
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            validator: validatePhone,
            message: "请输入正确的电话号码",
            trigger: "blur",
          },
        ],
      },
      ifRequire: true,
      tableData: [],
      fileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      imgUrl: "", //营业执照的url
      data: "", //上传图片数据
      IMGurl1: "",
      submitVisible: false,
      //存储资质相关url
      qualificationsPic: [],
      brandPic: [],
      industryPic: [],
      whetherCompany:null,//企业名称是否在工商数据中
    };
  },
  methods: {
    submitForm() {
      // localStorage.setItem("companyName", this.ruleForm.name);
      // localStorage.setItem("companyphone", this.ruleForm.phone);
      let data = {
        base: this.baseList,
        brand: this.brandList,
        industry: this.industryList,
      };
      localStorage.setItem("data", JSON.stringify(data));
      this.baseList &&
        this.baseList.forEach((itemB) => {
          this.qualificationsPic.forEach((itemQ) => {
            if (itemQ.picName == itemB.name) {
              itemQ.isChoice = itemB.isChoice;
            }
          });
        });
      this.brandList &&
        this.brandList.forEach((itemB) => {
          this.brandPic.forEach((itemQ) => {
            if (itemQ.picName == itemB.name) {
              itemQ.isChoice = itemB.isChoice;
            }
          });
        });
      this.industryList &&
        this.industryList.forEach((itemB) => {
          this.industryPic.forEach((itemQ) => {
            if (itemQ.picName == itemB.name) {
              itemQ.isChoice = itemB.isChoice;
            }
          });
        });
      if (this.evaluateWay) {
        this.$router.push({ path: "/diagnose/ECommerce/smartDiagnose" });
      } else {
        //必须上传营业执照
        let index = this.qualificationsPic.findIndex((item) => {
          return (item.picName == "企业营业执照");
        });
        if (this.qualificationsPic[index].picUrl == "") {
          this.$message("请上传企业营业执照");
        } else {
          this.submitVisible = true;
        }
      }
    },
    // 选择资质
    chooseBase(item) {
      item.isChoice = !item.isChoice;
    },
    // 删除文件
    handleRemove(file, fileList) {
      // 根据uid，删除对应的url
      this.qualificationsPic.forEach((item) => {
        if (item.uid == file.uid) {
          item.picUrl = "";
        }
      });
      this.brandPic.forEach((item) => {
        if (item.uid == file.uid) {
          item.picUrl = "";
        }
      });
      this.industryPic.forEach((item) => {
        if (item.uid == file.uid) {
          item.picUrl = "";
        }
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //随机key
    setKey(type) {
      var myDate = new Date();
      var key =
        "zc_" +
        Math.round(Math.random() * 10000) +
        myDate.getTime() +
        myDate.getFullYear() +
        myDate.getMonth() +
        myDate.getDate() +
        `.${type}`;
      return key;
    },
    // 上传图片
    fileUpload(file) {
      // 此时可以自行将文件上传至服务器
      let data = new FormData();
      let type = file.file.type.split("/")[1];
      data.append("Bucket", this.data.Bucket);
      data.append("OSSAccessKeyId", this.data.OSSAccessKeyId);
      data.append("Signature", this.data.Signature);
      data.append("key", this.setKey(type));
      data.append("policy", this.data.policy);
      data.append("success_action_status", this.data.success_action_status);
      data.append("url", this.data.url);
      data.append("file", file.file);
      axios.post(this.data.url, data).then((res) => {
        var doc = new DOMParser().parseFromString(res.data, "text/xml");
        let url = doc.getElementsByTagName("Location")[0].innerHTML;
        if (res.status == "201") {
          var doc = new DOMParser().parseFromString(res.data, "text/xml");
          let url = doc.getElementsByTagName("Location")[0].innerHTML;
          this.IMGurl1 = url;
          // console.log(file);
          if ((file.data.type = "基础资质")) {
            this.qualificationsPic.forEach((item) => {
              if (file.data.name == item.picName) {
                item.picUrl = this.IMGurl1;
              }
            });
          } else if ((file.data.type = "品牌资质")) {
            this.brandPic.forEach((item) => {
              if (file.data.name == item.picName) {
                item.picUrl = this.IMGurl1;
              }
            });
          } else {
            this.industryPic.forEach((item) => {
              if (file.data.name == item.picName) {
                item.picUrl = this.IMGurl1;
              }
            });
          }
          this.$message("上传成功");
        }
      });
    },
    imgUpload(file) {
      this.fileUpload(file);
      // 保存对应的uid，用于删除时的对应
      if ((file.data.type = "基础资质")) {
        this.qualificationsPic.forEach((item) => {
          if (file.data.name == item.picName) {
            item.uid = file.file.uid;
          }
        });
      } else if ((file.data.type = "品牌资质")) {
        this.brandPic.forEach((item) => {
          if (file.data.name == item.picName) {
            item.uid = file.file.uid;
          }
        });
      } else {
        this.industryPic.forEach((item) => {
          if (file.data.name == item.picName) {
            item.uid = file.file.uid;
          }
        });
      }
    },
    // 立即查看
    viewNow() {
      // this.$router.push({ path: "/diagnose/personal/myDiagnosis" });
      // console.log(localStorage.getItem("mainClass"));
      let getQualification = JSON.parse(
        localStorage.getItem("getQualification")
      );
      let corporateType;
      switch (getQualification.storeType) {
        case "旗舰店":
          corporateType = "qjd";
          break;
        case "专卖店":
          corporateType = "zmd";
          break;
        case "专营店":
          corporateType = "zyd";
          break;
        default:
          break;
      }
      let mainClass = JSON.parse(localStorage.getItem("mainClass"));
      this.submitVisible = false;
      let params = {
        enterprise: localStorage.getItem("companyName"), //企业名称
        mobile: localStorage.getItem("companyphone"), //联系电话
        qualificationsPic: this.qualificationsPic,
        brandPic: this.brandPic,
        industryPic: this.industryPic,
        corporateType,
        diagnosisType: "ds",
        mainClass,
        whetherCompany:this.whetherCompany
      };
      manualEvaluation(params).then((res) => {
        if (res.status === 0) {
          this.$router.push({
            path: "/diagnose/personal/artificialDiagnose",
            query: { diagnosis_no: res.data.diagnosis_no },
          });
        }else if(res.status == -99){
          this.$message('登录超时，请重新登录')
          this.logout()
        }
      });
    },
    logout() {
      logout(getCookie("userpin")).then((res) => {
        if (res.status == 0) {
          removeCookie("userpin");
          removeCookie("username");
          // this.$message({
          //   message: "已退出登录！",
          //   type: "success",
          // });
          this.$router.push("/diagnose");
        } else {
          this.$message.error("退出登录失败！");
        }
      });
    },
  },
  mounted() {
    // 获取资质列表
    let params = JSON.parse(localStorage.getItem("getQualification"));
    getQualificationByIndustry(params).then((res) => {
      if (res.status === 0) {
        let { base, brand, industry,whetherCompany } = res.data;
        this.whetherCompany = whetherCompany
        console.log(whetherCompany,"whetherCompany")
        localStorage.setItem('whetherCompany',JSON.stringify(whetherCompany))
        if (base[0] == "暂停接受入驻") {
          this.ifRequire = false;
        } else {
          this.baseList = base;
          this.brandList = brand;
          this.industryList = industry;
          let dataArr = [];
          // item.submit_code == "1"  这个字段 == '1',是人工审核需要上传的资质
          if (this.baseList) {
            base.forEach((item) => {
              if (item.submit_code == "1") {
                dataArr.push({ type: "基础资质", name: item.name });
              }
              this.qualificationsPic.push({ picName: item.name, picUrl: "" });
              if (item.isChoice) {
                this.checkbaseList.push(item.name);
              }
            });
          }
          if (this.brandList) {
            brand.forEach((item) => {
              if (item.submit_code == "1") {
                dataArr.push({ type: "品牌资质", name: item.name });
              }
              this.brandPic.push({ picName: item.name, picUrl: "" });
              if (item.isChoice) {
                this.checkBrandList.push(item.name);
              }
            });
          }
          if (this.industryList) {
            industry.forEach((item) => {
              if (item.submit_code == "1") {
                dataArr.push({ type: "行业资质", name: item.name });
              }
              this.industryPic.push({ picName: item.name, picUrl: "" });
              if (item.isChoice) {
                this.checkindustryList.push(item.name);
              }
            });
          }
          this.tableData = dataArr;
        }
        this.isShow = true;
      }else if(res.status == -99){
        this.$message('登录超时，请重新登录')
        this.logout()
      }
    });
    getOss().then((res) => {
      if (res.status == 0) {
        this.data = res.data;
        this.imgUrl = res.data.url;
      }else if(res.status == -99){
        this.$message('登录超时，请重新登录')
        this.logout()
      }
    });
  },
};
</script>

<style lang="scss" >
.zzzd_BEContainer {
  background: #ebecef;
  width: 100%;
  min-height: 100%;
  border-top: 1px solid #ebecef;
  padding-bottom: 29px;
  .zzzd_BEWrapper {
    width: 1190px;
    min-height: 100%;
    background: #fff;
    height: 90%;
    margin: 29px auto 0;
    padding: 40px 27px 0;
    .zzzd_steps {
      display: flex;
      .zzzd_circle {
        width: 32px;
        height: 32px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        font-family: HelveticaNeue;
        line-height: 32px;
        text-align: center;
        border-radius: 50%;
        border: 1px solid rgba(0, 0, 0, 0.15);
        &.active {
          background: #d7443f;
          border: 1px solid #d7443f;
          color: #fff;
        }
        &.active_icon {
          // background: #D7443F;
          border: 1px solid #d7443f;
          color: #d7443f;
        }
      }
      .zzzd_step {
        width: 64px;
        height: 24px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 24px;
        margin: 4px 8px;
        &.active {
          color: #000;
        }
      }
      .zzzd_line {
        width: 192px;
        height: 1px;
        background: rgba(0, 0, 0, 1);
        opacity: 0.15;
        margin-top: 17px;
        margin-right: 15px;
        margin-left: 22px;
      }
    }
    .zzzd_title {
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(19, 19, 19, 1);
      line-height: 33px;
      margin-top: 40px;
      margin-bottom: 30px;
    }
    .zzzd_table {
      width: 1132px;
      // height: 119px;
      border: 1px solid rgba(235, 235, 235, 1);
      margin-bottom: 30px;
      .zzzd_th {
        width: 1132px;
        height: 37px;
        background: rgba(245, 245, 245, 1);
        padding: 7px 18px;
        box-sizing: border-box;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
      }
      .zzzd_td {
        padding: 26px 20px;
        box-sizing: border-box;
        .el-checkbox__input.is-checked .el-checkbox__inner {
          background-color: #d7443f;
          border-color: #d7443f;
        }
        .el-checkbox__input.is-checked + .el-checkbox__label {
          color: #d7443f;
        }
        .el-checkbox__inner:hover {
          border-color: #d7443f;
        }
        .el-checkbox__input.is-focus .el-checkbox__inner {
          border-color: #d7443f;
        }
        .el-radio__input.is-checked .el-radio__inner {
          border-color: #d7443f;
          background: #d7443f;
        }
        .el-radio__input.is-checked + .el-radio__label {
          color: #d7443f;
        }
      }
    }
    .startBtn {
      width: 249px;
      height: 62px;
      background: #d7443f;
      border-radius: 4px;
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      margin-left: 443px;
      margin-top: 58px;
      margin-bottom: 35px;
    }
    // .demo-ruleForm {
    //   .el-form-item__content {
    //     width: 400px;
    //   }
    //   .el-button {
    //     width: 249px;
    //     height: 62px;
    //     background: #d7443f;
    //     border-radius: 4px;
    //     font-size: 26px;
    //     font-family: PingFangSC-Medium, PingFang SC;
    //     font-weight: 500;
    //     color: rgba(255, 255, 255, 1);
    //     margin-left: 443px;
    //     margin-top: 58px;
    //     margin-bottom: 35px;
    //   }
    // }
  }
  .up_circle {
    width: 32px;
    height: 32px;
    font-size: 16px;
    font-family: HelveticaNeue;
    line-height: 32px;
    text-align: center;
    border-radius: 50%;
    margin: 0 auto 20px;
    &.active {
      background: #d7443f;
      border: 1px solid #d7443f;
      color: #fff;
    }
  }
}
</style>